export default "__VITE_ASSET__BBcSefEu__"